import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { GoogleSignInButton } from "@/components/GoogleSignInButton";
import { toast } from "sonner";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", unit_number: "", phone: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to the community!");
      navigate("/portal");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="register-page" className="max-w-md mx-auto px-6 py-20">
      <p className="text-xs tracking-[0.3em] uppercase text-[#C86650] mb-2">Homeowner</p>
      <h1 className="font-serif text-4xl text-[#1A2421] mb-2">Create your account.</h1>
      <p className="text-[#5C6A64] mb-8">Register your household to access the portal.</p>
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded-2xl border border-[#D5CFC4] space-y-5">
        <GoogleSignInButton label="Sign up with Google" />
        <div className="flex items-center gap-4 text-xs text-[#5C6A64]">
          <div className="h-px flex-1 bg-[#D5CFC4]" />
          <span>or with email</span>
          <div className="h-px flex-1 bg-[#D5CFC4]" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-[#5C6A64]">Full name</label>
          <Input data-testid="reg-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-2 rounded-xl h-11" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-[#5C6A64]">Email</label>
          <Input data-testid="reg-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-2 rounded-xl h-11" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-[#5C6A64]">Password</label>
          <Input data-testid="reg-password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-2 rounded-xl h-11" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-xs uppercase tracking-wider text-[#5C6A64]">Unit / Address</label>
            <Input data-testid="reg-unit" value={form.unit_number} onChange={(e) => setForm({ ...form, unit_number: e.target.value })} className="mt-2 rounded-xl h-11" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-[#5C6A64]">Phone</label>
            <Input data-testid="reg-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-2 rounded-xl h-11" />
          </div>
        </div>
        <Button data-testid="reg-submit" type="submit" disabled={loading} className="w-full rounded-full h-12 bg-[#2C4C3B] hover:bg-[#233D2F]">
          {loading ? "Creating…" : "Create account"}
        </Button>
        <p className="text-sm text-[#5C6A64] text-center">
          Already registered? <Link data-testid="link-login" to="/login" className="text-[#C86650] underline">Sign in</Link>
        </p>
      </form>
    </div>
  );
}
